<template>
    <!-- Store Reservation Table Card -->
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 0 }">
        <template #title>
            <a-row type="flex" align="middle">
                <a-col :span="24" :md="12">
                    <h5 class="font-semibold m-0">门店预约·数据表格</h5>
                </a-col>
            </a-row>
        </template>
        <a-row :gutter="24" type="flex">
            <!-- Store Reservation Table Column -->
            <a-col :span="24" class="mb-24">
                <a-form layout="inline" :form="dataForm" @submit="getDataList" class="ml-20">
                    <a-form-item label="客户">
                        <a-select v-model="dataForm.customer_id" show-search placeholder="请选择客户" style="width: 200px"
                            :filter-option="false" :loading="customerLoading" @search="handleCustomerSearch"
                            @change="handleCustomerChange" allowClear>
                            <a-select-option v-for="customer in customerList" :key="customer.customer_id"
                                :value="customer.customer_id">
                                {{ customer.customer_name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="订台费">
                        <a-select v-model="dataForm.reservation" placeholder="订台费" style="width: 120px" allowClear>
                            <a-select-option value="1">已收</a-select-option>
                            <a-select-option value="2">未收</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="状态">
                        <a-select v-model="dataForm.status" placeholder="状态" style="width: 120px" allowClear>
                            <a-select-option value="1">已预约</a-select-option>
                            <a-select-option value="2">已到店</a-select-option>
                            <a-select-option value="3">已取消</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="预约时间">
                        <a-range-picker v-model="dataForm.visit_time_range" format="YYYY-MM-DD"
                            @change="handleVisitTimeChange" />
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="getDataList" :loading="dataListLoading">搜索</a-button>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="addOrUpdateHandle()">新增预约</a-button>
                    </a-form-item>
                </a-form>

                <a-table :key="tableKey" :columns="columns" :data-source="dataList" :pagination="false" rowKey="id"
                    :loading="dataListLoading" :scroll="{ x: 1500 }" :expandRowByClick="true" :indentSize="0"
                    :expandIconColumnIndex="0" :expandedRowKeys="expandedRowKeys"
                    @expandedRowsChange="handleExpandedRowsChange">
                    <template slot="customer.customer_name" slot-scope="customer_name">
                        {{ customer_name }}
                    </template>
                    <template slot="reservation" slot-scope="reservation">
                        <a-tag :color="reservation === '1' ? 'green' : 'orange'">
                            {{ reservation === '1' ? '已收订台费' : '未收订台费' }}
                        </a-tag>
                    </template>
                    <template slot="status" slot-scope="status">
                        <a-tag :color="getStatusColor(status)">
                            {{ getStatusText(status) }}
                        </a-tag>
                    </template>
                    <template slot="visit_time" slot-scope="visit_time">
                        <span>{{ visit_time ? formatDateTime(visit_time) : '-' }}</span>
                    </template>
                    <template slot="create_time" slot-scope="create_time">
                        <span>{{ formatDateTime(create_time) }}</span>
                    </template>
                    <template slot="editBtn" slot-scope="text, row">
                        <a-button type="link" @click.stop="addOrUpdateHandle(row.id)">
                            编辑
                        </a-button>
                        <a-button type="link" @click.stop="deleteHandle(row.id)">
                            删除
                        </a-button>
                    </template>
                    <template slot="expandedRowRender" slot-scope="record">
                        <div class="expanded-content">
                            <div v-if="record.sms_log" class="sms-log-content">
                                {{ record.sms_log }}
                            </div>
                            <div v-else class="no-sms-log">
                                <a-empty description="暂无短信日志" />
                            </div>
                        </div>
                    </template>
                </a-table>
            </a-col>
            <!-- / Store Reservation Table Column -->
        </a-row>

        <a-pagination class="mr-20 float-right" show-size-changer :current="page" :total="total"
            :show-total="(total) => `共 ${total} 条数据`" @showSizeChange="showSizeChange"
            @change="pageCurrentChangeHandle" />
        <addorupdate ref="addOrUpdate" @ok="getDataList"></addorupdate>
    </a-card>
    <!-- / Store Reservation Table Card -->
</template>

<script>
import viewModule from "@/mixins/view-module";
import addorupdate from "./components/addorupdate.vue";
export default {
    mixins: [viewModule],
    components: {
        addorupdate,
    },
    data() {
        return {
            mixinViewModuleOptions: {
                getDataListURL: "/admin/storereservation/page",
                deleteURL: "/admin/storereservation/delete",
            },
            dataForm: {
                customer_id: undefined,
                reservation: undefined,
                status: undefined,
                visit_time_range: [],
            },
            customerList: [],
            customerLoading: false,
            customerSearchTimer: null,
            tableKey: 0,
            expandedRowKeys: [],
            columns: [
                {
                    title: "客户姓名",
                    dataIndex: "customer.customer_name",
                    width: 150,
                    scopedSlots: { customRender: "customer.customer_name" },
                },
                // {
                //     title: "客户ID",
                //     dataIndex: "customer_id",
                //     width: 120
                // },
                {
                    title: "人数",
                    dataIndex: "num",
                    width: 80
                },
                {
                    title: "实际到店人数",
                    dataIndex: "num_true",
                    width: 120
                },
                {
                    title: "人物关系",
                    dataIndex: "relationship",
                    width: 120
                },
                {
                    title: "订台费",
                    dataIndex: "reservation",
                    width: 100,
                    scopedSlots: { customRender: "reservation" },
                },
                {
                    title: "状态",
                    dataIndex: "status",
                    width: 100,
                    scopedSlots: { customRender: "status" },
                },
                {
                    title: "预约时间",
                    dataIndex: "visit_time",
                    width: 180,
                    scopedSlots: { customRender: "visit_time" },
                },
                {
                    title: "特殊备注",
                    dataIndex: "remark",
                    width: 200
                },
                {
                    title: "创建时间",
                    dataIndex: "create_time",
                    width: 180,
                    scopedSlots: { customRender: "create_time" },
                },
                {
                    title: "操作",
                    scopedSlots: { customRender: "editBtn" },
                    width: 200,
                    // fixed: "right",
                    align: "center",
                },
            ],
        };
    },
    methods: {
        // 客户搜索
        handleCustomerSearch(value) {
            if (this.customerSearchTimer) {
                clearTimeout(this.customerSearchTimer);
            }
            this.customerSearchTimer = setTimeout(() => {
                if (value && value.trim()) {
                    this.searchCustomers(value.trim());
                } else {
                    this.customerList = [];
                }
            }, 300);
        },
        // 搜索客户
        searchCustomers(customerName) {
            this.customerLoading = true;
            this.$http({
                url: "/admin/customer/page",
                method: "get",
                params: {
                    customer_name: customerName,
                    page: 1,
                    limit: 20 // 限制返回数量
                }
            }).then((res) => {
                this.customerLoading = false;
                if (res.code === 1) {
                    this.customerList = res.data.result || [];
                } else {
                    this.customerList = [];
                    this.$message.error(res.msg || '搜索客户失败');
                }
            }).catch(() => {
                this.customerLoading = false;
                this.customerList = [];
            });
        },
        // 客户选择变化
        handleCustomerChange(value) {
            this.dataForm.customer_id = value;
        },
        // 处理展开行变化事件
        handleExpandedRowsChange(expandedRows) {
            // 记录当前展开的行，不需要强制重新渲染表格
            this.expandedRowKeys = expandedRows;
        },
        // 新增/编辑预约
        addOrUpdateHandle(id) {
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id);
            });
        },
        // 删除预约
        deleteHandle(id) {
            this.$confirm({
                title: '确认删除',
                content: '删除后不可恢复，请谨慎操作',
                okText: '确认删除',
                okType: 'danger',
                cancelText: '取消',
                onOk: () => {
                    this.$http({
                        url: "/admin/storereservation/delete",
                        method: "post",
                        data: { id: id }
                    }).then((res) => {
                        if (res.code === 1) {
                            this.$message.success('删除成功');
                            this.getDataList();
                        } else {
                            this.$message.error(res.msg || '删除失败');
                        }
                    }).catch((error) => {
                        console.error('删除失败:', error);
                        this.$message.error('删除失败');
                    });
                }
            });
        },
        // 格式化日期时间
        formatDateTime(dateTime) {
            if (!dateTime) return '-';
            const date = new Date(dateTime);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        },
        // 格式化日期为 YYYY-MM-DD 格式
        formatDate(date) {
            if (!date) return '';
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        // 处理预约时间范围变化
        handleVisitTimeChange(dates) {
            if (dates && dates.length === 2) {
                this.dataForm.visit_time_start = this.formatDate(dates[0]) + ' 00:00:00';
                this.dataForm.visit_time_end = this.formatDate(dates[1]) + ' 23:59:59';
            } else {
                this.dataForm.visit_time_start = undefined;
                this.dataForm.visit_time_end = undefined;
            }
        },
        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                '1': '已预约',
                '2': '已到店',
                '3': '已取消'
            };
            return statusMap[status] || '未知';
        },
        // 获取状态颜色
        getStatusColor(status) {
            const colorMap = {
                '1': 'blue',    // 已预约 - 蓝色
                '2': 'green',   // 已到店 - 绿色
                '3': 'red'      // 已取消 - 红色
            };
            return colorMap[status] || 'default';
        },
    },
};
</script>

<style scoped>
.expanded-content {
    padding: 16px;
    background-color: #fafafa;
    border-radius: 4px;
    margin: 8px 0;
}

.sms-log-item {
    margin-bottom: 16px;
}

.sms-log-item p {
    margin-bottom: 8px;
    line-height: 1.5;
}

.sms-log-item strong {
    color: #333;
    margin-right: 8px;
}

.no-sms-log {
    text-align: center;
    padding: 20px;
}

.sms-log-content {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: 'Courier New', monospace;
    /* overflow-y: auto;
    max-width: 100%;
    box-sizing: border-box; */
}

/* 确保表格展开时操作列不会错位 */
.ant-table-expanded-row>td {
    padding: 0 !important;
}

.ant-table-expanded-row .expanded-content {
    margin: 0;
    border-radius: 0;
}
</style>